import { CrossMarkSVG } from '@media/svgs/CrossMarkSVG'
import SuccessIcon from '@media/svgs/SuccessIcon'
import { BUY_BONUS_TEXTS, BUY_BONUS_PAYMENT_STATUS } from '@constants/buyBonusConstants'

// Pure render — terminal SUCCESS/FAILURE screen. All state lives in
// useBuyBonusFlow; this component only receives and displays it.
const BuyBonusPaymentStatus = ({
  paymentStatus,
  selectedPackage,
  currencyCode,
  onClose,
  onFinalAction,
}) => {
  const isSuccess = paymentStatus === BUY_BONUS_PAYMENT_STATUS.SUCCESS
  const INFO = BUY_BONUS_TEXTS.PACKAGE_PAYMENT_STATUS[paymentStatus] ?? BUY_BONUS_TEXTS.PACKAGE_PAYMENT_STATUS.FAILURE

  return (
    <div className="standard-normal-buy-bonus-payment-status-outer-container">
      <div className="standard-normal-buy-bonus-payment-status-inner-container">
        <div className="standard-normal-buy-bonus-payment-status-close-container" onClick={onClose}>
          <CrossMarkSVG width="16px" height="16px" />
        </div>

        <div className="standard-normal-buy-bonus-payment-status-info-container">
          <div className="standard-normal-buy-bonus-payment-status-icon-container">
            <div
              className={`standard-normal-buy-bonus-payment-status-icon-background ${isSuccess ? 'success' : 'failure'}`}
            >
              {isSuccess ? <SuccessIcon size={22} /> : <CrossMarkSVG width="18px" height="18px" />}
            </div>
          </div>

          <div className="standard-normal-buy-bonus-payment-status-message-container">
            {INFO.MESSAGE}
          </div>

          <div
            className={`standard-normal-buy-bonus-payment-status-amount-container ${isSuccess ? 'success' : 'failure'}`}
          >
            {currencyCode} {selectedPackage?.packageValue}
          </div>
        </div>

        <div className="standard-normal-buy-bonus-payment-status-action-container">
          <div className="standard-normal-buy-bonus-payment-status-action-text-container">
            {INFO.ACTION_TEXT}
          </div>
          <div className="standard-normal-buy-bonus-payment-status-action-button-container">
            <button
              className="standard-normal-buy-bonus-payment-status-action-button"
              onClick={onFinalAction}
            >
              {INFO.ACTION_BUTTON_TEXT}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BuyBonusPaymentStatus
